import { render, staticRenderFns } from "./NotificationWidget.vue?vue&type=template&id=5e1abb8e&lang=pug"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"
import style0 from "./NotificationWidget.vue?vue&type=style&index=0&id=5e1abb8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports